import loadable from '@loadable/component';

export const ProductTabStatisticsLegacy = loadable(
  () =>
    import(
      /* webpackChunkName: "product-tab-statistics-legacy" */ './product-tab-statistics'
    )
);
